import { apiClient } from '../client';

export interface Lookup {
  id: number;
  listName: string;
  value: string;
  label: string;
  sort: number;
  parentId: number | null;
  isDefault: boolean;
  editable: boolean;
  active: boolean;
}

export interface CreateLookupInput {
  listName: string;
  value: string;
  label: string;
  sort?: number;
  isDefault?: boolean;
  active?: boolean;
}

export type UpdateLookupInput = Partial<Omit<CreateLookupInput, 'listName'>>;

export const lookupsApi = {
  async byList(listName: string, includeInactive = false): Promise<Lookup[]> {
    const { data } = await apiClient.get<Lookup[]>('/lookups', {
      params: { listName, includeInactive: includeInactive || undefined },
    });
    return data;
  },
  async names(): Promise<string[]> {
    const { data } = await apiClient.get<string[]>('/lookups/names');
    return data;
  },
  async create(input: CreateLookupInput): Promise<Lookup> {
    const { data } = await apiClient.post<Lookup>('/lookups', input);
    return data;
  },
  async update(id: number, input: UpdateLookupInput): Promise<Lookup> {
    const { data } = await apiClient.patch<Lookup>(`/lookups/${id}`, input);
    return data;
  },
  async remove(id: number): Promise<void> {
    await apiClient.delete(`/lookups/${id}`);
  },
};
